module.exports = __webpack_public_path__ + "img/us.d42af5ad.png";